import type { Notebook } from "./reportTypes"

export function latestNotebookRevision(notebook: Notebook): number {
  return Math.max(
    notebook.revision,
    ...(notebook.revisions ?? []).map((entry) => entry.revision),
  )
}

export function reportRevisionHistory(notebook: Notebook) {
  return (
    notebook.revisions ??
    Array.from({ length: notebook.revision }, (_, index) => ({
      revision: index + 1,
      created_at: "",
    }))
  )
}
